// 天氣資料介面
export interface WeatherData {
  location: string;
  date: string;
  weather: string;
  temperature: {
    min: number;
    max: number;
  };
  icon: string;
  description: string;
}

// 天氣摘要介面
export interface WeatherSummary {
  location: string;
  summary: string;
  dailyWeather: WeatherData[];
}

// 台灣縣市選項
export interface TaiwanCity {
  value: string;
  label: string;
  cwbCode: string;
}

// 出勤表格職位資料
export interface AttendancePosition {
  title: string;           // 職稱
  requiredCount: number;    // 應到人數
  actualCount: number;      // 實到人數
  leaveCount: number;       // 休假人數
  attendanceStatus: string; // 今日出勤人員
  workingHours: {
    start: string;          // 上班時間
    end: string;            // 下班時間
  };
}

// 出勤表格資料
export interface AttendanceTable {
  positions: AttendancePosition[];
  totalRequired: number;    // 應到總計（自動計算）
  totalActual: number;      // 實到總計（自動計算）
  totalLeave: number;       // 休假總計（自動計算）
}

// 預設職稱列表
export const DEFAULT_POSITIONS = [
  '經理',
  '副理',
  '財務秘書',
  '行政秘書',
  '機電',
  '保全',
  '清潔'
];

// 台灣縣市列表（前端用）
export const TAIWAN_CITIES: TaiwanCity[] = [
  { value: 'taipei', label: '臺北市', cwbCode: '臺北市' },
  { value: 'new-taipei', label: '新北市', cwbCode: '新北市' },
  { value: 'keelung', label: '基隆市', cwbCode: '基隆市' },
  { value: 'taoyuan', label: '桃園市', cwbCode: '桃園市' },
  { value: 'hsinchu-city', label: '新竹市', cwbCode: '新竹市' },
  { value: 'hsinchu-county', label: '新竹縣', cwbCode: '新竹縣' },
  { value: 'miaoli', label: '苗栗縣', cwbCode: '苗栗縣' },
  { value: 'taichung', label: '臺中市', cwbCode: '臺中市' },
  { value: 'changhua', label: '彰化縣', cwbCode: '彰化縣' },
  { value: 'nantou', label: '南投縣', cwbCode: '南投縣' },
  { value: 'yunlin', label: '雲林縣', cwbCode: '雲林縣' },
  { value: 'chiayi-city', label: '嘉義市', cwbCode: '嘉義市' },
  { value: 'chiayi-county', label: '嘉義縣', cwbCode: '嘉義縣' },
  { value: 'tainan', label: '臺南市', cwbCode: '臺南市' },
  { value: 'kaohsiung', label: '高雄市', cwbCode: '高雄市' },
  { value: 'pingtung', label: '屏東縣', cwbCode: '屏東縣' },
  { value: 'yilan', label: '宜蘭縣', cwbCode: '宜蘭縣' },
  { value: 'hualien', label: '花蓮縣', cwbCode: '花蓮縣' },
  { value: 'taitung', label: '臺東縣', cwbCode: '臺東縣' },
  { value: 'penghu', label: '澎湖縣', cwbCode: '澎湖縣' },
  { value: 'kinmen', label: '金門縣', cwbCode: '金門縣' },
  { value: 'lienchiang', label: '連江縣', cwbCode: '連江縣' }
];